module.exports = __webpack_public_path__ + "static/media/Bandcamp-rond.e0447829.png";